export type ITimberlandAppraisalFormFirstSection = {
    TaxYear?: string;
}

export const TimberlandAppraisalFormFirstSectionInterface = (): ITimberlandAppraisalFormFirstSection => ({
    TaxYear: undefined
})